import { render } from "./PublicHeader.vue?vue&type=template&id=ad7fe964&scoped=true&ts=true"
import script from "./PublicHeader.vue?vue&type=script&lang=ts"
export * from "./PublicHeader.vue?vue&type=script&lang=ts"

import "./PublicHeader.vue?vue&type=style&index=0&id=ad7fe964&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad7fe964"]])

export default __exports__